// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text__medium[data-v-0f65208b]{font-size:14px;font-weight:400;line-height:1.36;letter-spacing:normal}.text__medium.bold[data-v-0f65208b]{font-weight:700}", ""]);
// Exports
module.exports = exports;
